const API_BASE = import.meta.env.VITE_API_BASE_URL
  ? (import.meta.env.VITE_API_BASE_URL.startsWith('http')
      ? new URL(import.meta.env.VITE_API_BASE_URL).origin
      : window.location.origin)
  : ''

export function reportError(error, extra = {}) {
  const appName = window.location.pathname.includes('/employee/') ? 'order-admin' : 'order-client'
  const payload = {
    message: error?.message || String(error),
    stack: error?.stack || '',
    url: window.location.href,
    userAgent: navigator.userAgent,
    app: appName,
    extra,
  }

  fetch(`${API_BASE}/api/errors/report/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).catch(() => {})
}

export function setupGlobalErrorHandlers() {
  window.addEventListener('error', (event) => {
    reportError(event.error || new Error(event.message), {
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    })
  })

  window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason instanceof Error
      ? event.reason
      : new Error(String(event.reason))
    reportError(error, { type: 'unhandledrejection' })
  })
}
